"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map(item => <NavigationMenuItem key={item.id}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="relative inline-flex h-9 items-center justify-center px-4 py-2 text-sm font-medium transition-colors hover:!bg-transparent focus:!bg-transparent group">
                  <span className="relative">
                    {item.label}
                    <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full" />
                  </span>
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
        {isMobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {}
      {isMobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-b shadow-medium md:hidden">
          <nav className="container mx-auto px-4 py-4">
            <ul className="flex flex-col gap-2">
              {menuItems.map(item => <li key={item.id}>
                  <Link to={item.href || "#"} className="block px-4 py-3 rounded-md text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground" onClick={() => setIsMobileMenuOpen(false)}>
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-background border-b transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isScrolled ? "h-14 shadow-soft" : "h-20"}`}>
      <div className="container mx-auto px-4 h-full flex items-center justify-between gap-8">
        <Link to="/" className="flex-shrink-0 hover:!bg-transparent focus:!bg-transparent">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1516646/img/km_mechanical_services_logo.png" alt="K&M Mechanical services" className="h-7" />
        </Link>

        <MenuProvider menu_id="4" className="flex-1 flex justify-center">
          <HeaderMenuConsumer />
        </MenuProvider>

        <Button asChild className="flex-shrink-0 hover:!bg-transparent focus:!bg-transparent transition-all duration-[120ms] ease-[var(--ease-spring)] hover:-translate-y-0.5 hover:shadow-medium active:translate-y-0">
          <Link to="/ContactPage">Get a Quote</Link>
        </Button>
      </div>
    </header>;
}